import './service.css';
import icon1 from './icon1.jpeg';
import icon2 from './icon2.jpeg';


function Service(){
    return(
        <section className='service'>
            <h1>Nossos Serviços</h1>

            <div className="card">
                <img src={icon1} alt="Pagina Web" />
                <h3>Landing Pages</h3>
                <p>Uma landing page é uma página da web criada com o propósito de direcionar visitantes para uma ação específica, como comprar um produto ou se inscrever em um serviço. Ela é projetada para ser simples e focada, eliminando distrações e destacando uma oferta ou chamada para ação.</p>
            </div>
            <div className="card">
                <img src={icon2} alt="Pagina Web" />
                <h3>Desenvolvimento de Sites</h3>
                <p>ApexLoom é uma empresa focada em dar vida às visões únicas de seus clientes através de websites personalizados. Combinamos criatividade e funcionalidade para construir plataformas online que refletem a essência de cada negócio.</p>
            </div>
        </section>
          
    );
}

export default Service;